module.exports = __webpack_public_path__ + "media/images/masjid-1ffe6e3d17f92a7cf863496a08811a42.jpg";